<rds-footer-sitemap-section >
    @if (title()) {
        <rds-footer-title class="c-white">{{title()}}</rds-footer-title>
    }
    
    @if (navigation()) {
        @for (item of navigation(); track $index) {
            <rds-footer-link [routerLink]="item.link" [attr.aria-label]="item.title" 
                (click)="onItemClick(item)" 
                (keydown.enter)="navigate(item.isExternal, item.link)">
                    {{item.title}}
                </rds-footer-link>
        }
    }

</rds-footer-sitemap-section>
